/**
 * Quill 2 serializes an empty line as `<p></p>`. The rest of the app expects the
 * Quill 1 shape, `<p><br></p>`: the backend sanitizer deletes empty tags, so
 * blank lines were lost on save (TS-3043), and the empty-description rules
 * compare against `<p><br></p>`.
 *
 * Both directions are needed. react-quill-new resets the editor whenever the
 * `value` prop differs from its own serialized string, so the value we pass in
 * must be converted back to Quill's shape.
 */

const EMPTY_BLOCK = /<(p|h[1-3]|li)><\/\1>/g;
const BLANK_LINE = /<(p|h[1-3]|li)><br><\/\1>/g;

export const fromQuillHtml = (html: string): string => html.replace(EMPTY_BLOCK, '<$1><br></$1>');

export const toQuillHtml = (html: string): string => html.replace(BLANK_LINE, '<$1></$1>');
